import { unicode } from "../../framework/utils/constants.js";
import { Body1 } from "../typography/Body1.js";
import { Body2 } from "../typography/Body2.js";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/divided-text/DividedText.tsx
const DividedText = ({ entries, divider = unicode.BULLET, variant = "body1", "data-testid": testId }) => {
	const filteredList = entries.filter((x) => x);
	return /* @__PURE__ */ jsx(variant === "body1" ? Body1 : Body2, {
		"data-testid": testId,
		children: filteredList.map((value, index) => {
			return index < filteredList.length - 1 ? /* @__PURE__ */ jsxs("span", { children: [
				value,
				"\xA0",
				divider,
				"\xA0"
			] }, `${value}-${index}`) : /* @__PURE__ */ jsx("span", { children: value }, `${value}-${index}`);
		})
	});
};

//#endregion
export { DividedText };